import { render } from "./tcos.vue?vue&type=template&id=3243081c"
import script from "./tcos.js?vue&type=script&lang=js&external"
export * from "./tcos.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__